import { Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  readonly online = signal(true);
  readonly reconnected = signal(false);

  private readonly apiUrl = environment.apiUrl;
  private timer?: ReturnType<typeof setTimeout>;
  private reconnectTimer?: ReturnType<typeof setTimeout>;
  private checking = false;
  private delay = 5000;

  setOnline(): void {
    if (this.online()) return;

    this.online.set(true);
    this.stopMonitoring();
    this.showReconnected();
  }

  setOffline(): void {
    if (!this.online()) return;

    this.online.set(false);
    this.reconnected.set(false);
    this.delay = 5000;
    this.scheduleCheck();
  }

  private scheduleCheck(): void {
    if (this.timer) return;

    this.timer = setTimeout(async () => {
      this.timer = undefined;
      await this.checkServer();

      if (!this.online()) {
        this.delay = Math.min(this.delay * 2, 30000);
        this.scheduleCheck();
      }
    }, this.delay);
  }

  private async checkServer(): Promise<void> {
    if (this.checking) return;

    this.checking = true;

    try {
      await fetch(this.apiUrl, {
        method: 'GET',
        cache: 'no-store'
      });

      this.setOnline();
    } catch {
      // Serveur toujours inaccessible.
    } finally {
      this.checking = false;
    }
  }

  private showReconnected(): void {
    this.reconnected.set(true);

    if (this.reconnectTimer) clearTimeout(this.reconnectTimer);

    this.reconnectTimer = setTimeout(() => {
      this.reconnected.set(false);
      this.reconnectTimer = undefined;
    }, 5000);
  }

  private stopMonitoring(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = undefined;
    }

    this.delay = 5000;
  }
}